const RECAPTCHA_ENABLED = "RECAPTCHA_ENABLED";
const HCAPTCHA_ENABLED = "HCAPTCHA_ENABLED";
const SET_HCAPTCHA_TOKEN = "SET_HCAPTCHA_TOKEN";
const RESET_CAPTCHA_TOKEN = "RESET_CAPTCHA_TOKEN";

export const recaptchaEnabled = () => ({ type: RECAPTCHA_ENABLED });
export const hcaptchaEnabled = () => ({ type: HCAPTCHA_ENABLED });
export const setHcaptchaToken = (hcaptchaToken) => ({ type: SET_HCAPTCHA_TOKEN, hcaptchaToken });
export const resetCaptchaToken = () => ({ type: RESET_CAPTCHA_TOKEN });

const captchaInit = {
  recaptcha: false,
  hcaptcha: false,
  hcaptchaToken: '',
};

export default function captchaReducer(state = captchaInit, action) {
  switch (action.type) {
    case RECAPTCHA_ENABLED:
      return { ...state, ...{ recaptcha: true, hcaptcha: false } };
    case HCAPTCHA_ENABLED:
      return { ...state, ...{ recaptcha: false, hcaptcha: true } };
    case SET_HCAPTCHA_TOKEN:
      return { ...state, ...{ hcaptchaToken: action.hcaptchaToken, hcaptcha: true } };
    case RESET_CAPTCHA_TOKEN:
      return { ...state, ...{hcaptchaToken: ''} }
    default:
    return state;
  }
}
